import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import classnames from "classnames";

import styles from "./content-word.module.css";
import { State } from "../../redux/store";
import { srcPath } from "../../util/Path";
import * as contentWordActions from "../../redux/actions/contentWord";
import { useImgLoaded } from "../../hooks/CustomHooks";
import { backToWeb } from "../../util/Util";
import { contentWordAudio } from "../../redux/actions/contentWord";

const transformCountdown = (
  countdown: number
): { text: string; fontSize: number } => {
  switch (countdown) {
    case undefined:
      return { text: "Match the picture with the word.", fontSize: 60 };
    case 4:
      return { text: "Ready?", fontSize: 120 };
    case 3:
    case 2:
    case 1:
      return { text: countdown.toString(), fontSize: 250 };
    case 0:
      return { text: "Start!", fontSize: 120 };
    default:
      return { text: "", fontSize: 100 };
  }
};

const IntroductionPage = () => {
  const dispatch = useDispatch();
  const { grade, unit, webUrl } = useSelector((state: State) => state.shared);
  const [countdown, setCountdown] = useState<number>();
  const [imgLoaded, addImgLoaded] = useImgLoaded(2);

  const onNext = () => {
    countdownLoop(5);
    contentWordAudio.timesUp.play();
    contentWordAudio.timesUp.src = srcPath("content-word/sounds/times_up.wav");
  };

  const countdownLoop = (second: number) => {
    if (second > 0) {
      contentWordAudio.countdown.play();
      second--;
      setCountdown(second);
      setTimeout(() => countdownLoop(second), 1000);
    } else {
      dispatch(contentWordActions.startPlay());
    }
  };

  return (
    <div style={{ display: imgLoaded ? "block" : "none" }}>
      <TransitionGroup>
        <CSSTransition
          key={countdown}
          timeout={150}
          classNames={{
            enter: styles.countdownEnter,
            enterActive: styles.countdownEnterActive,
            exit: styles.countdownExit,
            exitActive: styles.countdownExitActive,
          }}
        >
          <div
            className={classnames("abs", styles.boardContainer)}
            style={{
              fontSize: `${transformCountdown(countdown).fontSize}px`,
            }}
          >
            {transformCountdown(countdown).text}
          </div>
        </CSSTransition>
      </TransitionGroup>

      {countdown === undefined && (
        <>
          <img
            className={classnames("btn", "main-btn", "abs", styles.back)}
            src={srcPath("shared/back.png")}
            alt=""
            onLoad={addImgLoaded}
            onClick={() => backToWeb("small_book", webUrl, grade, unit)}
          />
          <img
            className={classnames("btn", "main-btn", "abs", styles.next)}
            src={srcPath("shared/next.png")}
            alt=""
            onLoad={addImgLoaded}
            onClick={onNext}
          />
        </>
      )}
    </div>
  );
};

export default IntroductionPage;
